export { default as VideosSlider } from './VideosSlider'
export { default as VideosProductContainer } from './VideosProductContainer'
export { default as VideosContainer } from './VideosContainer'